/**
 *
 * Asynchronously loads the component for MonitoringPage
 *
 */

import { lazyLoad } from "utils/loadable"

export const MonitoringPage = lazyLoad(
  () => import("./index"),
  module => module.MonitoringPage,
)
